import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-cfab1bc0"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "tab-bar"
};
const _hoisted_2 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "RECEPTION", -1));
const _hoisted_3 = ["src"];
const _hoisted_4 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "STATISTICS", -1));
const _hoisted_5 = ["src"];
const _hoisted_6 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "PERFORMANCE", -1));
const _hoisted_7 = ["src"];
const _hoisted_8 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "PERSONAL", -1));
const _hoisted_9 = ["src"];
import { ref, onMounted } from "vue";
import { useRoute, useRouter } from "vue-router";
export default {
  __name: 'tab-bar',
  setup(__props) {
    const active = ref(0);
    const route = useRoute();
    const router = useRouter();
    const icon = [{
      active: require('../assets/icons/svg/reception_active.svg'),
      inactive: require('../assets/icons/svg/reception.svg')
    }, {
      active: require('../assets/icons/svg/statistics_active.svg'),
      inactive: require('../assets/icons/svg/statistics.svg')
    }, {
      active: require('../assets/icons/svg/performance_active.svg'),
      inactive: require('../assets/icons/svg/performance.svg')
    }, {
      active: require('../assets/icons/svg/personal_active.svg'),
      inactive: require('../assets/icons/svg/personal.svg')
    }];
    const onChange = index => {};

    //active绑定路由。解决切换其他tab重新刷新active为0
    onMounted(() => {
      // 初始化 active 值
      setActiveTab();

      // 监听路由变化
      router.afterEach(() => {
        setActiveTab();
      });
    });
    function setActiveTab() {
      const path = route.path;
      switch (path) {
        case '/reception':
          active.value = 0;
          break;
        case '/statistics':
          active.value = 1;
          break;
        case '/performance':
          active.value = 2;
          break;
        case '/personal':
          active.value = 3;
          break;
        default:
          active.value = 0;
          break;
      }
    }
    return (_ctx, _cache) => {
      const _component_van_tabbar_item = _resolveComponent("van-tabbar-item");
      const _component_van_tabbar = _resolveComponent("van-tabbar");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_van_tabbar, {
        modelValue: active.value,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => active.value = $event),
        onChange: onChange,
        placeholder: true,
        "safe-area-inset-bottom": true
      }, {
        default: _withCtx(() => [_createVNode(_component_van_tabbar_item, {
          replace: "",
          to: "/reception"
        }, {
          icon: _withCtx(props => [_createElementVNode("img", {
            src: props.active ? icon[0].active : icon[0].inactive
          }, null, 8, _hoisted_3)]),
          default: _withCtx(() => [_hoisted_2]),
          _: 1
        }), _createVNode(_component_van_tabbar_item, {
          replace: "",
          to: "/statistics"
        }, {
          icon: _withCtx(props => [_createElementVNode("img", {
            src: props.active ? icon[1].active : icon[1].inactive
          }, null, 8, _hoisted_5)]),
          default: _withCtx(() => [_hoisted_4]),
          _: 1
        }), _createVNode(_component_van_tabbar_item, {
          replace: "",
          to: "/performance"
        }, {
          icon: _withCtx(props => [_createElementVNode("img", {
            src: props.active ? icon[2].active : icon[2].inactive
          }, null, 8, _hoisted_7)]),
          default: _withCtx(() => [_hoisted_6]),
          _: 1
        }), _createVNode(_component_van_tabbar_item, {
          replace: "",
          to: "/personal"
        }, {
          icon: _withCtx(props => [_createElementVNode("img", {
            src: props.active ? icon[3].active : icon[3].inactive
          }, null, 8, _hoisted_9)]),
          default: _withCtx(() => [_hoisted_8]),
          _: 1
        })]),
        _: 1
      }, 8, ["modelValue"])]);
    };
  }
};